module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('jin-dialog', {
    attrs: {
      "custom-class": "ushk-report-dialog",
      "size": "large",
      "width": "80%"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "ushk-report-dialog__title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), (_vm.visible) ? _c('report-content', {
    attrs: {
      "type": _vm.type,
      "data": _vm.data,
      "border": ""
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ef23b66","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/modules/ReportDialog.vue
// module id = 0GbP
// module chunks = 6